import React from 'react';
import { Link } from 'react-router-dom';

export default function NotFoundPage() {
  return (
    <div className="min-h-screen flex items-center justify-center px-4 bg-gradient-to-b from-primary/5 to-transparent" data-testid="not-found-page">
      <div className="text-center">
        <p className="text-6xl font-bold text-primary mb-4" style={{ fontFamily: 'Outfit, sans-serif' }}>404</p>
        <h1 className="text-2xl font-bold mb-2">Page not found</h1>
        <p className="text-muted-foreground mb-6">The page you're looking for doesn't exist or has been moved.</p>
        <Link to="/" className="inline-block rounded-full bg-primary text-primary-foreground px-8 py-3 font-bold shadow-lg hover:shadow-xl transition-all" data-testid="not-found-home-link">
          Back to home
        </Link>
      </div>
    </div>
  );
}
